import React, { useState, useEffect } from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

const CookieBanner = () => {
  const [show, setShow] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShow(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "true");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div 
      style={{ 
        position: "fixed", 
        bottom: "20px", 
        left: "20px", 
        right: "20px", 
        backgroundColor: "#1a2141", 
        color: "white", 
        padding: "20px", 
        borderRadius: "15px", 
        boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
        zIndex: 9999,
        border: "1px solid rgba(255,255,255,0.1)"
      }}
    >
      <Container className="d-flex flex-column flex-md-row align-items-center justify-content-between">
        <p className="mb-3 mb-md-0 me-md-4" style={{ fontSize: "0.9rem", margin: 0 }}>
          {t("cookies.text")}{" "}
          <Link to="/privatnost" style={{ color: "#7772f1", fontWeight: "600" }}>
            {t("cookies.privacyLink")}
          </Link>.
        </p>
        <Button 
          variant="primary" 
          onClick={acceptCookies}
          className="btn-custom"
          style={{ whiteSpace: "nowrap" }}
        >
          {t("cookies.acceptBtn")}
        </Button>
      </Container>
    </div>
  );
};

export default CookieBanner;
